import { ISpecialBusinessNameType } from '../types/bussines';
import { FREE_ZONE_KEYWORD } from './productDefinitions';

export const getSpecialBusinessNameText = (specialBusinessType?: ISpecialBusinessNameType) => {
  if (!specialBusinessType?.name) return '';
  const isFreeZone = specialBusinessType?.name?.toLowerCase().includes(FREE_ZONE_KEYWORD);
  const specialBusinessNameText = isFreeZone ? FREE_ZONE_KEYWORD : specialBusinessType?.name;
  return specialBusinessNameText?.replace(/_/g, ' ');
};
